<template>
  <g>
    <defs>
      <path
        id="certified@1x-a"
        d="M19.9804996,6.18652132 C19.9218613,5.96719336 19.7779539,5.78041998 19.5808265,5.66779672 L15.1589119,3.11669209 C14.9639151,3.00242476 14.7314515,2.97048374 14.5128618,3.02792337 C14.2942721,3.085363 14.1075404,3.22745752 13.9939074,3.42282465 L12.0040458,6.87531957 L10.0141842,3.42282465 C9.90055121,3.22745752 9.71381956,3.085363 9.49522986,3.02792337 C9.27664015,2.97048374 9.04417654,3.00242476 8.84917975,3.11669209 L4.42726507,5.66779672 C4.23013768,5.78041998 4.08623032,5.96719336 4.02759201,6.18652132 C3.9713118,6.40204561 4.0018455,6.63104833 4.11262883,6.82429748 L7.51410167,12.6323123 C7.13462233,13.3275254 6.92483133,14.1025866 6.90183656,14.8942918 C6.89629325,17.0096549 8.19663995,18.9090525 10.1707401,19.6691317 C12.1448402,20.429211 14.3832225,19.8923151 15.7977439,18.3194448 C17.2122653,16.7465744 17.5095232,14.4639771 16.545012,12.5812903 L19.8614481,6.83280116 C19.9861311,6.64203129 20.0290216,6.40919738 19.9804996,6.18652132 Z M6.05146835,6.71374961 L8.99374235,5.0130132 L11.731928,9.79208253 C10.5647297,9.8641946 9.45871243,10.3390607 8.60257297,11.1356643 L6.05146835,6.71374961 Z M12.0040458,18.2957646 C10.1254642,18.2957646 8.60257297,16.7728734 8.60257297,14.8942918 C8.60257297,13.0157102 10.1254642,11.4928189 12.0040458,11.4928189 C13.8826274,11.4928189 15.4055186,13.0157102 15.4055186,14.8942918 C15.4055186,16.7728734 13.8826274,18.2957646 12.0040458,18.2957646 Z M15.4055186,11.1101533 C14.9438347,10.688466 14.4073939,10.3567956 13.8238338,10.1322298 L12.9904729,8.57605599 L15.048364,5.0130132 L17.990638,6.71374961 L15.4055186,11.1101533 Z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <rect
        width="24"
        height="24"
        fill="#E3E3E3"
        fill-opacity=".01"
        style="mix-blend-mode:color-burn"
      />
      <use :fill="currentColor" :opacity="opacity"" fill-rule="nonzero" xlink:href="#certified@1x-a" />
    </g>
  </g>
</template>

<script>
  export default {
    props: {
      currentColor: {
        type: String,
        default: 'black'
      },
      opacity: {
        type: String,
        default: '1'
      }
    }  
  }
</script>